import React from 'react';
import { Link } from 'react-router-dom';

const solutions = [
  {
    title: 'Multi-Dwelling Units (MDU)',
    path: '/mdu',
    desc: 'Managed WiFi that attracts tenants, boosts revenue, and sets your properties apart. Single-pane-of-glass management with AI-optimized coverage for every unit.'
  },
  {
    title: 'Hospitality',
    path: '/hospitality',
    desc: 'Guest WiFi with Personal Area Networks, automatic authentication, and real-time service management. Guests average 2.9 devices each — we keep them all connected.'
  },
  {
    title: 'Education',
    path: '/education',
    desc: 'Secure campus networks with device restriction, content filtering, network segmentation, and 802.1X authentication. Built for the demands of digital learning.'
  },
  {
    title: 'Warehouses',
    path: '/warehouses',
    desc: 'Industrial-grade WiFi designed for challenging RF environments. Reliable coverage for barcode scanners, inventory systems, fleet management, and IoT devices.'
  }
];

const Solutions = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '60px 40px' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Solutions by Industry</h1>
        <p style={{ color: '#a0aec0', fontSize: '1.1rem', marginBottom: '50px', lineHeight: '1.7' }}>
          Every industry has unique connectivity challenges. Our solutions are purpose-built
          to address the specific requirements of your vertical.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '24px' }}>
          {solutions.map((solution, i) => (
            <Link key={i} to={solution.path} style={{
              padding: '32px', backgroundColor: '#0a1628', borderRadius: '12px',
              border: '1px solid #1a2744', textDecoration: 'none', color: '#fff'
            }}>
              <h2 style={{ fontSize: '1.4rem', marginBottom: '12px', color: '#60a5fa' }}>{solution.title}</h2>
              <p style={{ color: '#a0aec0', lineHeight: '1.7', margin: 0 }}>{solution.desc}</p>
              <span style={{ color: '#2563eb', marginTop: '16px', display: 'inline-block', fontWeight: '600' }}>
                Learn more &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Solutions;
